import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import {VideoGridElement} from '../../_shared/videos-grid/video-grid-element.model';


@Component({
  selector: 'app-changeaddress',
  templateUrl: './changeaddress.component.html',
  styleUrls: ['./changeaddress.component.scss']
})
export class ChangeaddressComponent implements OnInit {

  // @ViewChild('staticTabs', { static: false }) staticTabs: TabsetComponent;
  id: number;
  // selectTab(tabId: number) {
  //   this.staticTabs.tabs[tabId].active = true;
  // }

  videos: VideoGridElement[] = [
    {
      url: 'https://www.youtube.com/embed/1GlIAxcW2gI',
      title: 'Disaster Relief - Change of Mailing Address',
      powerpoint: null
    }

  ];

  constructor(private actRoute: ActivatedRoute) {
    this.id = this.actRoute.snapshot.params.id;
  }
  ngAfterViewInit() {
    // console.log(this.id);
    // this.selectTab(this.id - 1);
  }

  ngOnInit() {
  }

}
